import _ from 'lodash';
import { Skill } from './skill';

export class RequiredAgentsInfo {
   skillName: string;
   activeAgents: number;
   requiredAgents: number;
   // Add Constructor
   constructor(skill: Skill) {
      this.skillName = skill.skillConfiguration.originName;
      this.activeAgents = skill.activeAgentIds.length;
      this.requiredAgents = skill.requiredAgentCount;
   }
}

export class RequiredAgentForSkills {
   skillName: string;
   activeAgents: number;
   requiredAgents: number;
   subSkills: RequiredAgentsInfo[];
   // Add Constructor
   constructor(skills: Skill[]) {
      this.skillName = _(skills)
         .map((skill) => skill.skillConfiguration.skillName)
         .max();
      this.activeAgents = _(skills)
         .map((skill) => skill.activeAgentIds.length)
         .min();
      this.requiredAgents = _(skills)
         .map((skill) => skill.requiredAgentCount)
         .max();
      this.subSkills = skills.map((skill) => new RequiredAgentsInfo(skill));
   }
}
